import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { Store } from '@ngxs/store';
import { List } from '@shared/models/interfaces/List.interface';
import { Procedure } from '@shared/models/interfaces/procedures.interface';
import { ProceduresService } from '@shared/providers/procedures.service';
import { UtilsService } from '@shared/providers/utils.service';
import { UserState } from '@shared/store/logged-user/user.state';

@Component({
  selector: 'app-process-form',
  templateUrl: './process-form.component.html',
  styleUrls: ['./process-form.component.scss'],
})
export class ProcessFormComponent implements OnInit {
  @Input() processInformation;
  @Input() showButton = true;
  @Output() submitEvent = new EventEmitter<any>();

  public procedures: List<Procedure>;
  public processForm: FormGroup;
  public token;
  public loading = true;

  constructor(
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private proceduresService: ProceduresService,
    private store: Store,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    this.processForm = this.initializeForm();
    this.token = this.store.selectSnapshot(UserState.getUserToken);

    this.procedures = await this.proceduresService.list(this.token, 1, '', 1000);

    if (this.processInformation) {
      this.processForm.patchValue(this.processInformation);
      this.procedureId.setValue(
        this.procedures.data.find(p => p.procedureId === Number(this.processInformation.procedureId))
      );
      this.procedureId.disable();
    }
    this.loading = false;
  }

  initializeForm(): FormGroup {
    return this.formBuilder.group({
      procedureId: ['', Validators.compose([Validators.required])],
      userProcedureDescription: ['', Validators.compose([Validators.required])],
    });
  }

  get procedureId() {
    return this.processForm.get('procedureId');
  }

  get userProcedureDescription() {
    return this.processForm.get('userProcedureDescription');
  }

  async submit(form: FormGroup) {
    if (form.invalid) {
      this.utils.validateAllFields(form);
      this.utils.showToast('', `${this.translate.instant('COMPONENTS.FORMS.CHECK_THE_FIELDS')}`);
    } else {
      this.submitEvent.emit({
        formData: {
          procedureId: this.procedureId.value.procedureId,
          userProcedureDescription: this.userProcedureDescription.value,
        },
      });
    }
  }
}
